module.exports = __webpack_public_path__ + "static/media/angel.68f5ac37.svg";